import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
// 重置样式组件
import CssBaseline from '@material-ui/core/CssBaseline';
// Store
import { Provider } from 'react-redux';
import store from './store';
// Router
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from './pages/Login/Login';
import LinkInfo from './pages/LinkInfo/LinkInfo';
import EmailLink from './pages/EmailLink/EmailLink';
import Layout from './pages/Layout/Layout';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import ToolEstateUser from './pages/ToolEstateUser/ToolEstateUser';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1A9AE7',
    },
  },
});

// 入口组件
class App extends PureComponent {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>

          <BrowserRouter>
            <Switch>
              <Route exact path="/" component={Login}></Route>
              <Route exact path="/login" component={Login}></Route>
              <Route exact path="/linkinfo" component={LinkInfo}></Route>
              <Route exact path="/emaillink" component={EmailLink}></Route>
              <Route exact path="/toolestate" component={ToolEstateUser}></Route>
              <Route exact path="/main/:menuid" component={Layout}></Route>
            </Switch>
          </BrowserRouter>


          {/* <BrowserRouter>
            <Route path='/' exact component={HomePage}></Route>
            <Route path='/home' exact component={Home}></Route>
            <Route path='/login' exact component={Login}></Route>
            <Route path='/user' exact component={User}></Route>
            <Route path='/settings' exact component={Settings}></Route>
            <Route path='/layout' exact component={Layout}></Route>
            <Route path='/myprofile' exact component={MyProfile}></Route>
            <Route path='/department' exact component={Department}></Route>
            <Route path='/department/team' exact component={Team}></Route>
            <Route path='/detail' exact render={() => <div>detail</div>}></Route>
          </BrowserRouter> */}


        </Provider>
      </ThemeProvider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));